"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.default = void 0;
exports.del = del;
exports.findByFlowInstId = findByFlowInstId;
exports.findById = findById;
exports.getApiFlowltemData = getApiFlowltemData;
exports.getFlowRouteData = getFlowRouteData;
exports.getFlowltemData = getFlowltemData;
exports.getHisStationDataForDPDY = getHisStationDataForDPDY;
exports.getInfoByRouteId = getInfoByRouteId;
exports.getList = getList;
exports.getProcessTaskByProcessPlanId = getProcessTaskByProcessPlanId;
exports.getSeqDetail = getSeqDetail;
exports.getStationDataForDPDY = getStationDataForDPDY;
exports.submit = submit;
exports.update = update;
var _request = _interopRequireDefault(require("@/utils/request"));
var _cloud = require("@/utils/cloud");
// 分页
function getList(query) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route/list',
    method: 'POST',
    data: query
  });
}

// id 查询
function findById(id) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route/' + id,
    method: 'get'
  });
}

// id 查询
function getProcessTaskByProcessPlanId(id) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/pm/process-task/process-plan/' + id,
    method: 'get'
  });
}

// 流程实例 id 查询
function findByFlowInstId(id) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route/findByFlowInstId/' + id,
    method: 'get'
  });
}
// 修改
function update(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route',
    method: 'put',
    data: data
  });
}

// 保存
function add(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route',
    method: 'post',
    data: data
  });
}

// 提交
function submit(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route/submit',
    method: 'post',
    data: data
  });
}

// 删除
function del(id) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route/del',
    method: 'delete',
    params: {
      id: id
    }
  });
}

// 提交
function getInfoByRouteId(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route/getFlowData',
    method: 'post',
    params: {
      routeId: data.routeId,
      sequence: data.sequence
    }
  });
}
function getFlowRouteData(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route/getFlowRouteData',
    method: 'post',
    data: data
  });
}
function getFlowltemData(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route/getFlowItemData',
    method: 'post',
    data: data
  });
}
function getApiFlowltemData(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route/getFlowItemDataApi',
    method: 'post',
    data: data
  });
}
function getSeqDetail(data) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/product-station-item/listStationItems',
    method: 'post',
    data: data
  });
}
function getStationDataForDPDY() {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route/getStationDataForDPDY',
    method: 'get'
  });
}
function getHisStationDataForDPDY(dataToSend) {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/trace/stack-route/getHisStationDataForDPDY',
    method: 'post',
    data: dataToSend
  });
}
var _default = exports.default = {
  getInfoByRouteId: getInfoByRouteId,
  getList: getList,
  getFlowRouteData: getFlowRouteData,
  getFlowltemData: getFlowltemData,
  getApiFlowltemData: getApiFlowltemData,
  getSeqDetail: getSeqDetail
};